/* src/app/components/control-module/form/form.component.css */
.static-text-center {
  text-align: center;
  font-weight: bold;
  padding: 20px;
  font-size: 18px;
}
.static-text {
  font-weight: bold;
  padding-left: 15px;
  padding-top: 30px;
  display: block;
  font-size: 16px;
}
.card-body {
  padding: 0.5em;
}
/*# sourceMappingURL=form.component.css.map */
